import { Model } from "backbone"

class AuthorCommunication extends Model {
  get urlRoot() {
    return "/author_communications"
  }
}

export default AuthorCommunication
